<div class="intro-message">
    <h1>Seller Center</h1>
    <hr class="intro-divider">
    <a [routerLink]="['/home/login']"><span class="network-name">Seller Center</span> Inicio de sesi&oacute;n</a>
</div>

